import { useIntl } from 'react-intl';
import { useRecoilState } from 'recoil';
import { ResetViewIcon } from '~/assets/workspace-icons';
import ToolbarButton from '~/components/toolbar/shared/ToolbarButton';
import { viewManagerState } from '~/state/atoms/engineAtoms';

export default function ResetViewTool() {
    const [viewManager] = useRecoilState(viewManagerState);
    const intl = useIntl();

    return (
        <ToolbarButton
            icon={<ResetViewIcon />}
            tooltip={intl.formatMessage({
                id: 'toolbar.resetView.tooltip',
            })}
            tooltipPlacement="bottom"
            onClick={() => viewManager?.resetViews()}
        />
    );
}
